import React from 'react';
import PropTypes from 'prop-types';
import { compose, getContext, pure } from 'recompose';
import { connect } from 'react-redux';
import { getAddressRefs } from 'selectors';
import AddressFieldsPayment from './form';

const propTypes = {
  areComponentsRendered: PropTypes.bool.isRequired,
  setAreComponentsRendered: PropTypes.func.isRequired,
  namespace: PropTypes.string,
  refs: PropTypes.shape({
    statesCollection: PropTypes.arrayOf(PropTypes.shape({})),
    countriesCollection: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  isRequired: PropTypes.bool,
  isFormDisabled: PropTypes.bool,
};

const defaultProps = {
  namespace: null,
  refs: {
    statesCollection: [],
    countriesCollection: [],
  },
  isRequired: true,
  isFormDisabled: false,
};

function AddressFields({
  isFormDisabled,
  namespace,
  refs,
  areComponentsRendered,
  setAreComponentsRendered,
  isRequired,
}) {
  return (
    <AddressFieldsPayment
      isFormDisabled={isFormDisabled}
      namespace={namespace}
      refs={refs}
      areComponentsRendered={areComponentsRendered}
      setAreComponentsRendered={setAreComponentsRendered}
      isRequired={isRequired}
    />
  );
}

AddressFields.propTypes = propTypes;
AddressFields.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    refs: getAddressRefs(state),
  };
}

const enhance = compose(
  getContext({
    areComponentsRendered: PropTypes.bool,
    setAreComponentsRendered: PropTypes.func,
    namespace: propTypes.string,
    isFormDisabled: PropTypes.bool,
  }),
  connect(mapStateToProps),
  pure,
);

export default enhance(AddressFields);
